import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
export default function Payments() {
    const { t } = useTranslation();
    return (_jsxs("div", { style: { padding: '24px' }, children: [_jsx("h1", { children: t('products.pagamentos') }), _jsx("p", { children: "P\u00E1gina do produto de Pagamentos em desenvolvimento." })] }));
}
